import { useAtomValue } from 'jotai';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { useUpdatePlan } from '@/hooks/useUpdatePlan';

import { itemByLanguage } from '@/utils/language';

import ManageTranslationsPopup from '@/components/popups/ManageTranslationsModal/ManageTranslations';
import type { ManageTranslationsState } from '@/components/popups/ManageTranslationsModal/state';
import ToastMessageBlock from '@/components/Toasts/SuccessToast';

import Constants from '@/constants';

import { Plan } from '@/_generated/api-clients/xp';
import { userPrefsAtom } from '@/atoms/userPrefs';

interface EditTranslationsProps {
  editTranslations: boolean;
  plan: Plan;
  refetchPlans: () => void;
  setEditTranslations: (show: boolean) => void;
}

const EditTranslations: React.FC<EditTranslationsProps> = ({
  editTranslations,
  plan,
  refetchPlans,
  setEditTranslations,
}) => {
  const { t } = useTranslation();
  const { language: userLanguage } = useAtomValue(userPrefsAtom);
  const { updateTranslations } = useUpdatePlan();

  const onSaveTranslations = async (updated: ManageTranslationsState) => {
    await updateTranslations(plan, {
      name: updated.name,
      sections: updated.content?.sections,
      steps: updated.content?.steps,
    });
    setEditTranslations(false);
    toast.custom(toastObj => (
      <ToastMessageBlock id={toastObj.id}>
        {`${itemByLanguage(updated.name)} ${t(
          'TrainingPlans.translationToastText',
        )} ${
          userLanguage === Constants.LANGUAGE.ENGLISH_LANGUAGE_CODE
            ? Constants.LANGUAGE_OPTIONS.SPANISH
            : Constants.LANGUAGE_OPTIONS.INGLES
        }`}
      </ToastMessageBlock>
    ));
    refetchPlans();
  };

  return (
    <ManageTranslationsPopup
      isOpen={editTranslations}
      onClose={() => setEditTranslations(false)}
      onSave={onSaveTranslations}
      translatableObject={plan}
    />
  );
};
export default EditTranslations;
